import { useState, useEffect, useRef } from "react";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import V2header from "./v2header";
import redmic from "../assets/redmic.png";
import Visualizersm from "./visulaizersm";
import useModalStore from "zustand/zustandstore";
import { Backdrop, CircularProgress, Tooltip } from "@mui/material";
import Addpatient from "./modals/addpatient";
import ToastMessage from "utils/muialerts/righttoptoast";
import api from "api/api";
import archeivesymbol from '../assets/arc.png'
import { useNavigate } from "react-router-dom";
import summarizedpng from '../assets/summarized.png'
import uploadicon from '../assets/uploadv2.png'
import { DateTime } from "luxon";
import disablemic from '../assets/disablemic.png'
import axios from "axios";
import GoogleMeetflow from "googlemeet/googlemeet";
import { convertToddmmyyy } from "utils/date";
const MainRecording = ({ setRosData,isuploadaudioflow, selectedTemplate,selectedRecord,setIsuploadmodal,checkConsent,handleStartRecording,errorMessage,setErrorMessage,setDetailsModal,
  templates,setSelectedTemplate, setPatientId,patientName, patientid,setPatientName,isDetailsmoadal,setui,loguser
}) => {
const navigate=useNavigate()
  const [isOpen, setIsOpen] = useState(false);
 const latestImageUrl = useRef('');
  const mydata = useModalStore();
        const [loading,setLoading]=useState(false)
  const [open, setOpen] = useState(false);
    const [alertmessage, setAlertMessage] = useState('');
        const [severity, setSeverity] = useState('success');
 const[myimgurl,setMyimgUrl]=useState('')
  const [data, setData] = useState({});
  const isDisabled = mydata?.usertype === 'PRO' && Object.keys(mydata?.selectedRecord || {}).length === 0;

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const percentage = 100;
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${percentage * 3.6}deg)`,
  };
  function checkImage(url, onSuccess, onError) {
    const img = new Image();
  
    img.onload = function () {
      console.log('image fetched successfully');
      onSuccess();
    };
  
    img.onerror = function () {
      console.log('Failed to load image');
      onError();
    };
  
    img.src = url;
  }
 useEffect(() => {
        
        
          if (typeof loguser === 'object' && loguser !== null && mydata?.selectedRecord?.patientid) {
            const imageUrl = `https://api.prd.brainymed.com/bs/patient-profile-pictures/${loguser?.config?.practiceid}/${mydata.selectedRecord?.patientid}.png`;
        
            latestImageUrl.current = imageUrl;
        
            checkImage(
              imageUrl,
              () => {
                // Only update state if the image URL hasn't changed since the request started
                if (latestImageUrl.current === imageUrl) {
                  setMyimgUrl(true);
                }
              },
              () => {
                if (latestImageUrl.current === imageUrl) {
                  setMyimgUrl(false);
                }
              }
            );
          }
        
        }, [mydata, loguser]);
      

  return (<>
    <div className="min-h-screen h-auto w-full flex flex-col">
    <div
  className="flex-1 w-full flex relative flex-col bg-gradient-to-b from-white to-[#A2C6FD]"
  style={
    mydata?.usertype === 'PRO' && Object.keys(mydata?.selectedRecord || {}).length === 0
      ? { background: 'rgba(217, 217, 217, 0.40)' }
      : {}
  }
>




    <div className="w-full flex flex-col-reverse sm:flex-row flex-wrap justify-center sm:justify-between">

        <div>

 {Object.keys(mydata?.selectedRecord || {}).length > 0&&mydata.usertype==='PRO'?<div className='flex relative w-full gap-4 mt-2 sm:mt-6  items-center p-4'>
 

        <div>
          <div
  className="relative flex justify-center items-center w-[83px] h-[83px] rounded-full ml-4"
  style={circleStyle}
>
  <div className="flex justify-center items-center w-[70px] h-[70px] bg-[#FAFAF9] rounded-full">
  <img
         src={myimgurl&&loguser&&Object.keys(mydata?.selectedRecord || {}).length > 0?`https://api.prd.brainymed.com/bs/patient-profile-pictures/${loguser?.config?.practiceid}/${mydata.selectedRecord?.patientid}.png`:
         'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
         alt="profile"
         className="flex justify-center items-center w-[50px] h-[50px] bg-[#C4C4C4] rounded-full"
       />
  </div>
</div>  
        </div>
    
        <div className="text-start font-sans  font-normal">
     {mydata.selectedRecord?.patient_name ||mydata.selectedRecord?.patientid ? (<>
       <div className="text-xxl flex items-center gap-4 sm:text-2xl text-gray-600">
         {mydata.selectedRecord?.patient_name}    {mydata?.usertype === 'PRO' && (
      <div className="rounded-lg sm:rounded-full text-center px-2   py-1 text-xs font-medium bg-[#bbd3f1] text-[#0E0E0E]">
     {selectedRecord?.purpose}
      </div>
    )}
       </div>
       <div className="text-xxl text-start text-gray-600">
       {mydata.selectedRecord?.patientid ? `${mydata.selectedRecord?.patientid}` : ''}
       </div>
     {mydata.usertype==='PRO'?<> <div className="text-xxl text-gray-600">{convertToddmmyyy(mydata.selectedRecord?.dob)||''}</div></>:<></>}
    </>) : null}
   </div>

          </div>:<div></div>}

        </div>


  <div>
      <V2header

  />
  </div>





</div>


        <div className="flex-1 flex flex-col justify-center items-center space-y-4">
       

{((Object.keys(mydata?.selectedRecord || {}).length === 0 && mydata.usertype === 'PRO') ||
  mydata.selectedRecord?.transcriptionstatus === 'Processing') && (
  <div className="rounded-md border absolute top-[30%] border-[#FCD34D] bg-[#FFFBEB] flex gap-2 justify-center items-center py-2  px-2 sm:px-8">
    {mydata.selectedRecord?.transcriptionstatus === 'Processing' ? (
      "🎙️ Recording is now in processing... Please wait."
    ) : (
      <>
      <div className=" flex items-center gap-2">
 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
          <path d="M7.99967 14.6654C11.6816 14.6654 14.6663 11.6806 14.6663 7.9987C14.6663 4.3168 11.6816 1.33203 7.99967 1.33203C4.31778 1.33203 1.33301 4.3168 1.33301 7.9987C1.33301 11.6806 4.31778 14.6654 7.99967 14.6654Z" stroke="#09090B" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 5.33203V7.9987" stroke="#09090B" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M8 10.668H8.00667" stroke="#09090B" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span className="text-xs sm:text-[16px]">
          
          Please select a patient from the list to start recording
          </span>

      </div>
       
      </>
    )}
  </div>
)}




<div

onClick={(e)=>{
 e.stopPropagation()
 isuploadaudioflow.current=false
  if((!selectedTemplate||selectedTemplate=='Choose Template')&&mydata.usertype!=='BUSINESS'){
    setSeverity('info')
   setAlertMessage('Select template before starting recording')
    setOpen(true)
    return
  }
  // if(selectedRecord.transcriptionstatus==='APPROVED'){
  //   setSeverity('info');
  //   setAlertMessage('Record Is Signed');
  //   setOpen(true);
  //   return;
  // }
  if (mydata.usertype === 'PRO') {
    if (!selectedRecord || typeof selectedRecord !== 'object' || !selectedRecord.patientid) {
      setSeverity('info');
      setAlertMessage('Please select a patient');
      setOpen(true);
      return;
    }
    setRosData('')
    checkConsent()
  return
   
  }
  
  setDetailsModal(true)
  }}
>
<div className="relative">
{(mydata?.usertype === 'PRO' && Object.keys(mydata?.selectedRecord || {}).length === 0) ? (
  <div
    className="w-24 sm:w-28 h-24 sm:h-28 rounded-full flex items-center justify-center"
    style={{ background: 'var(--color-azure-65, #9CA3AF)' }}
  >
    <img src={disablemic} alt="Disabled Mic" className="w-10 sm:w-16" />
  </div>
) : (
  <img src={redmic} alt="Red Mic" className="w-18 sm:w-28 cursor-pointer" />
)}

 
  
  {(mydata?.usertype === 'PLUS')||(mydata?.usertype==='PRO'&&Object.keys(mydata?.selectedRecord || {}).length > 0) ? (
    <img 
      src={uploadicon} 
      alt="Upload" 
      className="absolute right-0 bottom-1 left-[90%] cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();

        if((!selectedTemplate||selectedTemplate=='Choose Template')&&mydata.usertype!=='BUSINESS'){
          setSeverity('info')
         setAlertMessage('Select template before starting recording')
          setOpen(true)
          return
        }

        if((mydata?.usertype==='PRO'&&Object.keys(mydata?.selectedRecord || {}).length > 0)){
          isuploadaudioflow.current=true
          checkConsent()
          return
        }
      setIsuploadmodal(true)
      }}
    />
  ):<></>}
</div>


 
</div>





         {mydata.usertype!=='BUSINESS'&&!isDisabled ?
         <>
         <div className={`font-normal text-[#4B5563] text-md`}>Choose Template</div>

          <div className="relative w-48 sm:min-w-[350px]">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="w-full flex justify-between items-center px-4 py-2 border border-gray-300 rounded-md bg-white text-gray-700"
            >
    {
  selectedTemplate === 'HnP'
    ? 'History & Physical'
    : selectedTemplate === 'soap_note'
    ? 'SOAP Note'
    : selectedTemplate || 'Choose Template'
}

              <FontAwesomeIcon icon={faChevronDown} className="text-gray-500" />
            </button>

            {isOpen && (
  mydata.usertype === '' ? (
    <ul className="absolute w-full text-start px-2 mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-10">
      <li
        className="px-4 py-2 cursor-pointer hover:bg-gray-100"
        onClick={() => {
          setSelectedTemplate("Soap Note");
          setIsOpen(false);
        }}
      >
        Soap Note
      </li>
      <li
        className="px-4 py-2 cursor-pointer hover:bg-gray-100"
        onClick={() => {
          setSelectedTemplate("HnP");
          setIsOpen(false);
        }}
      >
        History & Physical
      </li>
    </ul>
  ) : (
    <ul className="absolute w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-10 max-h-48 overflow-y-auto">
    {templates.map((template, index) => (
      <li
        key={index}
        className="px-4 py-2 cursor-pointer hover:bg-gray-100 text-start"
        onClick={() => {
          setSelectedTemplate(template);
          setIsOpen(false);
        }}
      >
      {template === 'HnP'
  ? 'History & Physical'
  : template === 'soap_note'
  ? 'SOAP Note'
  : template}

      </li>
    ))}
  </ul>
  
  )
)}

          </div></>:<></>
          }
 
<div className="flex justify-end items-end gap-2">

<div
  className={`font-normal text-md ${
    isDisabled
      ? 'text-gray-400'
      : 'text-[#4B5563]'
  }`}
>
  Test your microphone
</div>

        
          <Visualizersm disabled={isDisabled}/>
</div>
{mydata?.selectedRecord?.patientid &&mydata.usertype==='PRO' && (
  <div
    onClick={() => {
      const timestamp = new Date().getTime();
      const profilePhotoUrl = null;
      if(mydata.usertype==='PRO'){
        navigate(`/archive/${mydata.selectedRecord.patientid}`, { state: { ts: timestamp, profile_photo: '',back:true } });
      }else if(mydata.usertype=='PLUS'||mydata.usertype=='BASIC'){
            navigate(`/basic-archive/${mydata.selectedRecord.patientid}`, {
        state: { ts: timestamp, profile_photo: profilePhotoUrl,back:true },
      });
      } 
     return
   
    }}
    className="flex gap-2 text-[#FFFFFF] min-w-[180px] px-8 py-2 text-center justify-center items-center bg-[#1C2A3A]  cursor-pointer text-md font-medium rounded-full border border-gray-300 flex-shrink-0"
  >
    <img src={archeivesymbol} alt="Archive" className="w-4 h-4" />
    <span className="">Archive</span>
  </div>
)}


          
        </div>
      </div>
    </div>

    <Addpatient 
   
    setPatientId={setPatientId} 
    patientName={patientName}
    setDetailsModal={setDetailsModal}
    patientId={patientid}
    isDetailsmoadal={isDetailsmoadal}
    setPatientName={setPatientName}
    errorMessage={errorMessage}
    setErrorMessage={setErrorMessage}
    handleStartRecording={handleStartRecording}
    
    />

    
<ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
    <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
  </>);
};

export default MainRecording;
